// Shared KPI display vocabulary (W5, parity polish). Lives here, not inside
// either module's format.ts, because both modules needed the exact same
// rule and a copy in each was already caught drifting apart in review.

/**
 * A KPI is always `Name (ID)`, never a bare id (workspace rule). An
 * attention headline the producer emits leads with the bare `kpi_id`
 * ("k040 down 56% ..."); this rewrites that leading token to
 * `<kpi_name> (<kpi_id>)` when the headline actually carries the tile's
 * own id, and leaves anything else untouched rather than guess.
 */
export function attentionHeadline(headline: string, kpiId: string, kpiName: string): string {
  if (!kpiId || !kpiName) return headline;
  if (headline === kpiId || headline.startsWith(`${kpiId} `)) {
    return `${kpiName} (${kpiId})${headline.slice(kpiId.length)}`;
  }
  return headline;
}
